var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54456 5.44954C4.54456 4.16088 5.58922 3.11621 6.87789 3.11621H9.5353C11.5041 3.11621 13.1001 4.71223 13.1001 6.68103C13.1001 7.70107 12.6717 8.62105 11.985 9.27083C13.0756 9.88044 13.8131 11.0465 13.8131 12.3847C13.8131 14.3535 12.2171 15.9495 10.2483 15.9495H6.86169C5.58197 15.9495 4.54456 14.9121 4.54456 13.6324V5.44954ZM6.87789 4.54214H9.5353C10.7166 4.54214 11.6742 5.49975 11.6742 6.68103C11.6742 7.8623 10.7166 8.81991 9.5353 8.81991H5.97048V5.44954C5.97048 4.9484 6.37674 4.54214 6.87789 4.54214ZM5.97048 10.2458V13.6324C5.97048 14.1246 6.36949 14.5236 6.86169 14.5236H10.2483C11.4295 14.5236 12.3871 13.566 12.3871 12.3847C12.3871 11.2035 11.4295 10.2458 10.2483 10.2458H5.97048Z",
    fill: "#33383F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/bold_icon.f11e0fdf17a420d562aee1d14dfb0e42.svg";
export { ForwardRef as ReactComponent };